var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"document-editor-container"},[_c('NoteDocumentEditor',{staticClass:"document-editor overflow-hidden",staticStyle:{"height":"100%"},attrs:{"doc":_vm.doc,"updateDocStateOnClose":_vm.updateDocStateOnClose,"isMobileView":_vm.isMobileView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }